import React, { useEffect } from "react";
import NextButton from "../../common/NextButton/NextButton";
import StepTitle from "../../common/StepTitle/StepTitle";
import useFormState from "../../hooks/useFormState";
import useLogin from "../../hooks/useLogin";
import AccountForm from "./AccountForm";
import LoggedInCard from "./LoggedInCard";
import LoginForm from "./LoginForm";

const Account = () => {
  const { isAuthenticated, user } = useLogin();
  const { actions } = useFormState();

  useEffect(() => {
    console.log("emit DisplayConnexion");
    window.top.postMessage("DisplayConnexion", "*");
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      actions.updateFormDataValue({
        userAccountData: user,
      });
      setTimeout(() => {
        actions.nextStep();
      }, 1000);
    }
  }, [user, isAuthenticated]);

  return (
    <div>
      <div className="d-flex flex-column flex-md-row align-items-start w-100">
        <div className="py-3 mb-4 w-100">
          <StepTitle
            text="Connexion à votre compte"
            subText="Connectez-vous ou créez votre compte pour finaliser votre commande."
          />
        </div>
      </div>

      <LoginForm />
      <AccountForm />
    </div>
  );
};

export default Account;
